

import React from 'react';
import moment from 'moment';

const BReport = ({ contentRef, DataObj }) => {
  return (
    <div ref={contentRef} style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', backgroundColor: 'white' }}>
      {/* Header */}
      <div style={{ marginBottom: '20px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 'bold',textAlign: 'center', color: '#635bff', marginBottom: '8px' }}>Clanbridge Living Pvt Ltd</h1>
        <h2 style={{ fontSize: '18px', fontWeight: 'bold',textAlign: 'center', marginBottom: '16px' }}>Booking </h2>
      </div>

      {/* Basic Info Section */}
      <div style={{ marginBottom: '20px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <thead>
            <tr style={{ backgroundColor: '#635bff' }}>
            <th style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'center', color: 'white', fontWeight: 'bold' }} colSpan="4">Booking Summary</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Booking No</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.BookNo || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Book Date</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookDt).format('DD-MM-YYYY')}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Mobile</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.MobileNo || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Email</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.Email || ''}</td>
            </tr>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>From Date</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookDtFrom).format('DD-MM-YYYY')}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>To Date</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookUpToDt).format('DD-MM-YYYY')}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Duration</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.Duration || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Property Name</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.PropName || ''}</td>
            </tr>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}> Resident Name</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }} colSpan="3"> {DataObj.ResidentName || ''}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Room Details Section */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#635bff', marginBottom: '8px' }}>Room Details</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <tbody>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Wing</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.WingName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Floor</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.FloorName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Room Type</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.RoomTypeName || ''}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Bed No</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.RoombedName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Bed Type</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.RoomBedTypeName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Standard Rent</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.BedRent || ''}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Plan Details Section */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#635bff', marginBottom: '8px' }}>Plan Details</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <tbody>
            {[
              [
                ['Plan', DataObj.PlanName || ''],
                ['Duration', DataObj.Duration || '']
              ],
              [
                ['Free Months', DataObj.FreeMonth || '0'],
                ['Min Adv Month', DataObj.LastAdjMonths || '0']
              ],
              [
                ['Increment %', DataObj.IncRentPerc || '0'],
                ['Deposit', DataObj.DepositAmt || '0']
              ],
              [
                ['Coupon', DataObj.CouponNo || 'N/A'],
                ['Discount', DataObj.DiscAmt || '0']
              ],
              [
                ['Total Rent', DataObj.TotalRent || '0'],
                ['Net Amount', DataObj.NetAmt || '0'],
                
              ],
              [
                ['Monthly Amount', DataObj.MonthlyAmt || '0'],
                ['Net Payable', DataObj.AdvcRcble || '0'],
                
              ]
            ].map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#f9fafb' : 'white' }}>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[0][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[0][1]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[1][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[1][1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Other Services Section */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#635bff', marginBottom: '8px' }}>Other Services</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <tbody>
            {[
              [
                ['Topup Amount', DataObj.TopupAmt || '0'],
                ['Transport Service', DataObj.TAmount || '0']
              ],
              [
                ['Mess Service', DataObj.MAmount || '0'],
                ['Total Amount', DataObj.TotalRent || '0']
              ]
            ].map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#f9fafb' : 'white' }}>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[0][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[0][1]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[1][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[1][1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div style={{ marginTop: '16px', fontSize: '12px' }}>
        <p style={{ marginBottom: '4px' }}>Thank you for choosing Clanbridge Living Pvt Ltd</p>
        <p>For any queries, please contact: support@clanbridgeliving.in</p>
      </div>
    </div>
  );
};

export default BReport;
